import { Injectable, Inject } from '@nestjs/common';
import { Repository, Raw, getConnection } from 'typeorm';
import { InjectRepository } from '@nestjs/typeorm';
import { StatesEntity } from './states.entity';
import { StatesDTO, StateStatusDTO } from './dto/states.dto';
import { StatesResponseModel, StatesStatusWiseResponseModel } from './dto/states-response.model';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { AllStatesResponseModel } from './dto/all-states-response.model';

@Injectable()
export class StatesService {
  constructor(
    @InjectRepository(StatesEntity)
    private statesRepository: Repository<StatesEntity>,
  ) { }

  async createState(queryParams, statesDto: StatesDTO, isUpdate: boolean, request: Request): Promise<StatesResponseModel> {
    const response = new StatesResponseModel();
    try {
      if (!isUpdate) {
        const StateExist = await this.getStateDetailsWithoutRelations(statesDto.stateName);
        if (StateExist) {
          throw new ErrorResponse(11104, 'State already exists');
        } else {
          if (queryParams.apiVersion == 1) {
            const savedState = await this.statesRepository.save(statesDto);
            if (savedState) {
              response.status = true;
              response.data = savedState;
              response.statusCode = 50000;
              response.internalMessage = 'State created successfully';
              response.intlCode = 11100;
            } else {
              throw new ErrorResponse(11106, 'State not created');
            }
          } else {
            console.log(statesDto)
            const savedState = await this.statesRepository.save(statesDto);
            if (savedState) {
              response.status = true;
              response.data = savedState;
              response.statusCode = 50000;
              response.internalMessage = 'State created successfully';
              response.intlCode = 11100;
            } else {
              throw new ErrorResponse(11106, 'State not created');
            }
          }
        }
      } else {
        if (queryParams.apiVersion == 1) {
          const updateState = await this.statesRepository.update(statesDto.Id, statesDto);
          if (updateState) {
            const updateDate = await this.statesRepository.findOne({
              where: { Id: statesDto.Id }
            })
            response.status = true;
            response.data = updateDate;
            response.statusCode = 50000;
            response.internalMessage = 'State updated successfully';
            response.intlCode = 11108;
          } else {
            throw new ErrorResponse(99998, 'State not updated');
          }
        } else {
          const updateState = await this.statesRepository.update(statesDto.Id, statesDto);
          if (updateState) {
            const updateDate = await this.statesRepository.findOne({
              where: { Id: statesDto.Id }
            })
            response.status = true;
            response.data = updateDate;
            response.statusCode = 50000;
            response.internalMessage = 'State updated successfully';
            response.intlCode = 11108;
          } else {
            throw new ErrorResponse(99998, 'State not updated');
          }
        }
      }
      return response;
    } catch (error) {
      throw error;
    }
  }

  async getStateDetailsWithoutRelations(stateName: string): Promise<StatesEntity> {
    const StateResponse = await this.statesRepository.findOne({
      where: { stateName: Raw(alias => `UPPER(state_name) = '${stateName.toLocaleUpperCase()}'`), status: true },
    });
    if (StateResponse) {
      return StateResponse;
    } else {
      return null;
    }
  }

  async getAllStates(queryParams, request:Request): Promise<AllStatesResponseModel> {
    const response = new AllStatesResponseModel();
    try {
      if (queryParams.apiVersion == 1) {
        const states = await this.statesRepository.find({
          order: { 'stateName': 'ASC' }
        });
        if (states) {
          response.status = true;
          response.data = states;
          response.statusCode = 50000;
          response.internalMessage = 'Data retrieved successfully';
          response.intlCode = 11108;
        } else {
          throw new ErrorResponse(99998, 'Data not found');
        }
      } else {
        const states = await this.statesRepository.find({
          order: { 'stateName': 'ASC' }
        });
        if (states) {
          response.status = true;
          response.data = states;
          response.statusCode = 50000;
          response.internalMessage = 'Data retrieved successfully';
          response.intlCode = 11108;
        } else {
          throw new ErrorResponse(99998, 'Data not found');
        }
      }
      return response;
    } catch (err) {
      throw err;
    }
  }

  async getStateByStateName(queryParams, stateName: string, request: Request): Promise<StatesResponseModel> {
    const response = new StatesResponseModel();
    try {
      if (queryParams.apiVersion == 1) {
        const stateRespone = await this.statesRepository.findOne({
          where: { stateName: Raw(alias => `UPPER(state_name) = '${stateName.toLocaleUpperCase()}'`) }
        });
        if (stateRespone) {
          response.status = true;
          response.statusCode = 50000;
          response.internalMessage = 'State record found';
          response.intlCode = 11107;
          response.data = stateRespone;
        } else {
          throw new ErrorResponse(99998, 'State record not found');
        }
      } else {
        const stateRespone = await this.statesRepository.findOne({
          where: { stateName: Raw(alias => `UPPER(state_name) = '${stateName.toLocaleUpperCase()}'`) }
        });
        if (stateRespone) {
          response.status = true;
          response.statusCode = 50000;
          response.internalMessage = 'State record found';
          response.intlCode = 11107;
          response.data = stateRespone;
        } else {
          throw new ErrorResponse(99998, 'State record not found');
        }
      }
      return response;
    } catch (error) {
      throw error;
    }
  }

  async getStateByStateId(queryParams, stateId: number, request:Request): Promise<StatesResponseModel> {
    const response = new StatesResponseModel();
    try {
      if (queryParams.apiVersion == 1) {
        const stateRespone = await this.statesRepository.findOne({
          where: { Id: Raw(alias => `id= '${stateId}'`) }
        });
        if (stateRespone) {
          response.status = true;
          response.statusCode = 50000;
          response.internalMessage = 'State record found';
          response.intlCode = 11107;
          response.data = stateRespone;
        } else {
          throw new ErrorResponse(99998, 'State record not found');
        }
      } else {
        const stateRespone = await this.statesRepository.findOne({
          where: { Id: Raw(alias => `id= '${stateId}'`) }
        });
        if (stateRespone) {
          response.status = true;
          response.statusCode = 50000;
          response.internalMessage = 'State record found';
          response.intlCode = 11107;
          response.data = stateRespone;
        } else {
          throw new ErrorResponse(99998, 'State record not found');
        }
      }
      return response;
    } catch (error) {
      throw error;
    }
  }

  async getAllActiveStates(queryParams, request:Request): Promise<AllStatesResponseModel> {
    const response = new AllStatesResponseModel();
    try {
      if (queryParams.apiVersion == 1) {
        const states = await this.statesRepository.find({
          where: { status: true },
          order: { createdAt: 'DESC' }
        });
        if (states) {
          response.status = true;
          response.data = states;
          response.statusCode = 50000;
          response.internalMessage = 'Data retrieved successfully';
          response.intlCode = 11108;
        } else {
          throw new ErrorResponse(99998, 'Data not found');
        }
      } else {
        const states = await this.statesRepository.find({
          where: { status: true },
          order: { createdAt: 'DESC' }
        });
        if (states) {
          response.status = true;
          response.data = states;
          response.statusCode = 50000;
          response.internalMessage = 'Data retrieved successfully';
          response.intlCode = 11108;
        } else {
          throw new ErrorResponse(99998, 'Data not found');
        }
      }
      return response;
    } catch (err) {
      throw err;
    }
  }
  
  async getActiveStatesCount(queryParams, request:Request): Promise<StatesStatusWiseResponseModel> {
    const response = new StatesStatusWiseResponseModel();
    try {
      if(queryParams.apiVersion == 1) {
        const statesStatusWiseCount = await getConnection()
        .createQueryBuilder()
        .select("Sum(IF(status = true, 1, 0)) as activeCount,Sum(IF(status = false, 1, 0)) as inActiveCount, count(*) as cnt")
        .from(StatesEntity, "States")
        .orderBy('status','ASC')
        .getRawOne();
        if (statesStatusWiseCount) {
          response.status = true;
          response.active = statesStatusWiseCount.activeCount;
          response.inActive = statesStatusWiseCount.inActiveCount;
          response.total = statesStatusWiseCount.cnt;
          response.statusCode = 50000;
          response.internalMessage = 'Data retrieved successfully';
          response.intlCode = 11108;
        } else {
          throw new ErrorResponse(99998, 'Data not found');
        }
      } else {
        const statesStatusWiseCount = await getConnection()
        .createQueryBuilder()
        .select("Sum(IF(status = true, 1, 0)) as activeCount,Sum(IF(status = false, 1, 0)) as inActiveCount, count(*) as cnt")
        .from(StatesEntity, "States")
        .orderBy('status','ASC')
        .getRawOne();
        if (statesStatusWiseCount) {
          response.status = true;
          response.active = statesStatusWiseCount.activeCount;
          response.inActive = statesStatusWiseCount.inActiveCount;
          response.total = statesStatusWiseCount.cnt;
          response.statusCode = 50000;
          response.internalMessage = 'Data retrieved successfully';
          response.intlCode = 11108;
        } else {
          throw new ErrorResponse(99998, 'Data not found');
        }
      }
      return response;
    } catch (err) {
      throw err;
    }
  }

  async updateStateStatus(queryParams,stateStatusDto:StateStatusDTO, request:Request):Promise<StatesResponseModel>{
    const response = new StatesResponseModel();
    try {
      if(queryParams.apiVersion == 1) {
        await this.statesRepository.update(stateStatusDto.Id,stateStatusDto);
        const states = await this.statesRepository.findOne({
          where: { Id:stateStatusDto.Id },
        });
        if (states) {
          response.status = true;
          response.data = states;
          response.statusCode = 50000;
          response.internalMessage = 'State status updated successfully';
          response.intlCode = 11108;
        } else {
        throw new ErrorResponse(99998, 'State status update failed');
        }
      } else {
        await this.statesRepository.update(stateStatusDto.Id,stateStatusDto);
        const states = await this.statesRepository.findOne({
          where: { Id:stateStatusDto.Id },
        });
        if (states) {
          response.status = true;
          response.data = states;
          response.statusCode = 50000;
          response.internalMessage = 'State status updated successfully';
          response.intlCode = 11108;
        } else {
          throw new ErrorResponse(99998, 'State status update failed');
        }
      }      
      return response;
    } catch (error) {
      throw error;
    }
  }
  
}
